module.exports = __webpack_public_path__ + "static/media/logo_molinera.da6e24be.png";